jQuery(document).ready(function () {
    jQuery(document).on('click', ".st-funnel-yes a, a.st-funnel-yes", function (e) {
        // Submit the form
        e.preventDefault();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event: 'upsellSuccess'}); //Push event to GTM
        
        /* if data-product-id attribute is set on the "st-funnel-yes" button, then override the form "orderdetails" value before submitting to the CRM */
        var productId = jQuery(this).attr('product-id');
        if (typeof productId !== typeof undefined && productId !== false) {
            jQuery('input[name="orderdetails"]').val(productId);
        }
        /* override form "orderdetails" value modification code ends */
        jQuery('#add_sale').submit();
    });

    jQuery(document).on('click', ".st-funnel-no a, a.st-funnel-no", function (e) {
        // Submit the form
        e.preventDefault();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({event: 'upsellRefused'}); //Push event to GTM
        jQuery('#skip_sale').submit();
    });
    jQuery('.st-funnel-yes a, a.st-funnel-yes, .st-funnel-no a, a.st-funnel-no').on('click', '.elementor-button-link', function (e) {
        e.preventDefault();
    });

    /* New code added for sticky footer feature */
    if ($('.st-footer').length > 0) {
        jQuery('<div id="st-spacer"></div>').appendTo('body');
    }

    function toggleStickyFooter() {
        $topOffset = jQuery(window).scrollTop();
        if ($topOffset > 600) {
            jQuery('.st-footer').fadeIn(400);
        } else {
            jQuery('.st-footer').fadeOut(250);
        }
    }
    toggleStickyFooter();
    jQuery(window).scroll(function () {
        toggleStickyFooter();
    });
    /* Sticky footer feature ends */
    var myarray = [];
    var myVariants = [];
    var myQties = [];
    $('[name="qty"]').on('change', function(e){
        e.preventDefault();
        let parent = jQuery(this).parents('.product-container');
        var product_id = $(parent).attr('data-product-id');
        var pos = $.inArray(product_id, myarray);

        if(pos){
            myQties[pos] = jQuery(this).val();
        }

    });
    $(".add_to_cart").click(function(event) {

        event.preventDefault();
        $(this).hide();

        let parent = jQuery(this).parents('.product-container');

        var product_id = $(parent).attr('data-product-id');
        var variant_id = $(parent).attr('data-variant-id');
        var qty = $(parent).find('[name="qty"]').val();

        $(parent).find('.remove_cart').show();

        myarray.push(product_id);
        myVariants.push(variant_id);
        myQties.push(qty);


    });

    $(".remove_cart").click(function(event) {
        event.preventDefault();
        $(this).hide();
        let parent = jQuery(this).parents('.product-container');
        var product_id = $(parent).attr('data-product-id');
        var variant_id = $(parent).attr('data-variant-id');

        $(parent).find('.add_to_cart').show();

        myarray.splice( $.inArray(product_id, myarray), 1 );
        myVariants.splice( $.inArray(variant_id, myVariants), 1 );

        // Splice according to the product index in each array
        myQties.Splice($.inArray(product_id, myarray), 1);

    });

    jQuery('.st-funnel-yes-multisell').on('click', function(e){

        if(myarray.length > 0 ){
            jQuery(myarray).each(function(k,v){
                jQuery('#add_sale').append("<input type='hidden' name='products[]' value='"+v+"'/>");
            });
            jQuery(myVariants).each(function(k,v){
                jQuery('#add_sale').append("<input type='hidden' name='variations[]' value='"+v+"'/>");
            });
            jQuery(myQties).each(function(k,v){
                jQuery('#add_sale').append("<input type='hidden' name='quantities[]' value='"+v+"'/>");
            });
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({event: 'upsellSuccess'}); //Push event to GTM

            /* if data-product-id attribute is set on the "st-funnel-yes" button, then override the form "orderdetails" value before submitting to the CRM */
            var productId = jQuery(this).attr('product-id');
            if (typeof productId !== typeof undefined && productId !== false) {
                jQuery('input[name="orderdetails"]').val(productId);
            }
            /* override form "orderdetails" value modification code ends */
            jQuery('#add_sale').submit();
            st_loader.toggle();

        }else{
            e.stopImmediatePropagation();
            alert('Please select atleast 1 product');
        }

    })
});
